import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})

export class ScrollSyncService {
	private scrollLeftSubject = new Subject<number>();

	public scrollLeft$ = this.scrollLeftSubject.asObservable();

	public sendScrollLeftPosition(scrollLeft: number) {
		this.scrollLeftSubject.next(scrollLeft);
	}
}
